import { useTags } from 'features/tags/hooks/use-tags';
import { useMemo } from 'react';

export const useTextFilteredTags = (searchText: string) => {
  const tags = useTags();

  return useMemo(() => {
    if (!searchText) {
      return [];
    }
    const trimmedSearchText = searchText.trim().toLowerCase();

    return tags
      .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [searchText, tags]);
};
